/** @format */

import config from "../config";
import http from "./httpServices";



//This is the only place where API is called from .
//If you wish to update the Endpoints Do it here.
//If you want to change The Api Address Change it in config.js File
export async function getAnimeList() {
  return await http.get(config.apiUrl + "/anime-list/");
}

export async function getAnimeDetails(id) {
  return await http.get(config.apiUrl + "/anime-detail/" + id + "/");
}

export async function getNews() {
  return await http.get(config.apiUrl + "/news/");
}
export async function getNewsDetails(id) {
  return await http.get(config.apiUrl + "/news/" + id + "/");
}

export async function getGenre() {
  return await http.get(config.apiUrl + "/genre/");
}

export async function searchAnime(query) {
  return await http.get(config.apiUrl + "/anime-detail/?search=" + query);
}

export async function getStudiosList() {
  return await http.get(config.apiUrl + "/studio/");
}

export async function PostAnimeList(obj) {
  http.setToken();
  return await http.post(config.apiUrl + "/anime-detail/", obj);
}

export async function GetOrderedAnimeList(order) {
  return await http.get(config.apiUrl + `/anime-detail/?ordering=${order}`);
}

export async function GetTrendingAnimeList() {
  return await http.get(config.apiUrl + "/anime-detail/?ordering=trending");
}

export async function GetAnimeByGenre(genre) {
  return await http.get(config.apiUrl + "/anime-detail/?genres=" + genre);
}

